import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from './types';

type Variables = { id: string; publicToken: string };
type Response = Reservation;

export const usePublicReservation = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['reservations/agreement'],
  fetcher: ({ id, publicToken }) => {
    return client
      .get(`v2/reservations/${id}/agreement`, {
        params: { public_token: publicToken },
      })
      .then((response) => response.data.data);
  },
});
